import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { DayPicker } from 'react-day-picker';
import moment from 'moment';
import { convertDateToMoment, convertMomentToDate } from 'helpers/datetime';
import Chevron from 'svg/chevron-right.svg';
import App from 'modules/App';
import { useLocale } from './hooks';
export const DayRangePicker = ({ range, disabled, isLocalTime = false, onChange })=>{
    if (!process.env.BROWSER) {
        return null;
    }
    const appLocale = useSelector(App.selectors.locale);
    const appDirection = useSelector(App.selectors.direction);
    const locale = useLocale(appLocale);
    const onDayClick = (date)=>{
        if (range.from && range.to) {
            onChange({
                from: convertDateToMoment(date, isLocalTime).startOf('day'),
                to: null
            });
        }
    };
    const onSelect = (newRange)=>{
        if (range.to && range.from) {
            return;
        }
        if (!range.from) {
            onChange({
                from: convertDateToMoment(newRange.from, isLocalTime).startOf('day'),
                to: null
            });
            return;
        }
        onChange({
            from: newRange ? convertDateToMoment(newRange.from, isLocalTime).startOf('day') : range.from,
            to: newRange ? convertDateToMoment(newRange.to, isLocalTime).endOf('day') : range.from.clone().endOf('day')
        });
    };
    const from = convertMomentToDate(range.from, isLocalTime);
    const to = convertMomentToDate(range.to, isLocalTime);
    const before = convertMomentToDate(disabled.before, isLocalTime);
    const after = convertMomentToDate(disabled.after, isLocalTime);
    let maxMoment;
    if (range.to) {
        maxMoment = range.to;
    } else if (disabled.after) {
        maxMoment = disabled.after;
    }
    const defaultMonth = maxMoment && new Date(maxMoment.clone().subtract(1, 'months').locale('en').format('YYYY-MM-DD'));
    const weekStartsOn = moment.localeData().firstDayOfWeek();
    return /*#__PURE__*/ _jsx(DayPicker, {
        mode: "range",
        numberOfMonths: 2,
        defaultMonth: defaultMonth,
        timeZone: isLocalTime ? undefined : 'UTC',
        locale: locale,
        dir: appDirection,
        numerals: appLocale === 'ar' ? 'arab' : 'latn',
        weekStartsOn: weekStartsOn,
        disabled: {
            before,
            after
        },
        selected: {
            from,
            to
        },
        components: {
            Chevron
        },
        animate: true,
        onDayClick: onDayClick,
        onSelect: onSelect
    });
};
